export async function asyncPoll<T>(fn: () => Promise<T>, pollInterval: number = 5 * 1000): Promise<T> {
    const checkCondition = (resolve, reject): void => {
        Promise.resolve(fn())
            .then(result => {
                setTimeout(checkCondition, pollInterval, resolve, reject);
            })
            .catch(err => {
                reject(err);
            });
    };
    return new Promise<T>(checkCondition);
}
